// VA-223: @w/id, not the @w/be-utils barrel - see tools/drizzle-js-ts-resolve.cjs.
import { customAlphabet } from '@w/id'

const uid = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz', 9)

export const getExternalId = () => `MW-${uid()}`
